import { createFileRoute } from '@tanstack/react-router'
import { documentActionSearchSchema } from '../../../../features/sales/document-action'
import { InvoiceDetailPage } from '../../../../features/sales/invoice-pages'

export const Route = createFileRoute('/_app/invoices/$invoiceId/')({
  validateSearch: documentActionSearchSchema,
  component: InvoiceDetailPage,
})
